import { compose, withStateHandlers } from 'recompose';
import PubSub from 'pubsub-js';
import withRouteStyles from '../../HOC/withRouteStyles';
import Header from './Header';

import { START_PROJECT_CLICK } from '../../../client/GoogleAnalytics/events';

const enhance = compose(
  withRouteStyles('header'),
  withStateHandlers(
    {
      hovered: false
    },
    {
      handleMouseEnter: () => () => ({ hovered: true }),
      handleMouseLeave: () => () => ({ hovered: false }),
      handleMouseClick: () => () => {
        PubSub.publish(START_PROJECT_CLICK);

        return { hovered: false };
      }
    }
  )
);

export default enhance(Header);
